import * as SecureStore from 'expo-secure-store';
import { Platform } from 'react-native';

const PENDING_AUTH_REDIRECT_KEY = 'auth.pendingRedirect';

function getWebStorage() {
  if (typeof localStorage === 'undefined') return null;
  if (typeof localStorage.getItem !== 'function') return null;
  if (typeof localStorage.setItem !== 'function') return null;
  if (typeof localStorage.removeItem !== 'function') return null;
  return localStorage;
}

export function normalizeAuthRedirect(redirect: string | null | undefined): string | null {
  if (!redirect) return null;
  if (!redirect.startsWith('/')) return null;
  if (redirect.startsWith('//')) return null;
  return redirect;
}

export async function setPendingAuthRedirect(redirect: string | null | undefined): Promise<void> {
  const normalized = normalizeAuthRedirect(redirect);

  if (!normalized) {
    await clearPendingAuthRedirect();
    return;
  }

  if (Platform.OS === 'web') {
    const storage = getWebStorage();
    if (storage) storage.setItem(PENDING_AUTH_REDIRECT_KEY, normalized);
    return;
  }

  await SecureStore.setItemAsync(PENDING_AUTH_REDIRECT_KEY, normalized);
}

export async function getPendingAuthRedirect(): Promise<string | null> {
  if (Platform.OS === 'web') {
    const storage = getWebStorage();
    return normalizeAuthRedirect(storage?.getItem(PENDING_AUTH_REDIRECT_KEY) ?? null);
  }

  return normalizeAuthRedirect(await SecureStore.getItemAsync(PENDING_AUTH_REDIRECT_KEY));
}

export async function clearPendingAuthRedirect(): Promise<void> {
  if (Platform.OS === 'web') {
    const storage = getWebStorage();
    if (storage) storage.removeItem(PENDING_AUTH_REDIRECT_KEY);
    return;
  }

  await SecureStore.deleteItemAsync(PENDING_AUTH_REDIRECT_KEY);
}

export async function consumePendingAuthRedirect(): Promise<string | null> {
  const redirect = await getPendingAuthRedirect();
  await clearPendingAuthRedirect();
  return redirect;
}
